import GetAppIcon from '@material-ui/icons/GetApp';
import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import React from 'styled-components';
import Button from '../../../ClientsTableList/components/Button';
import DownloadPdf from '../Sheet';
import { IExportPdf } from './interface';

function ExportPdf(props: IExportPdf) {
  const componentRef: any = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <>
      <div style={{ display: 'none' }}>
        <DownloadPdf
          ref={componentRef}
          title={props.title}
          body={props.body}
          isLastTwelveMonths={false}
        />
      </div>
      <Button.Info style={{ color: '#125c5b' }}>
        <GetAppIcon style={{ color: '#125c5b' }} onClick={handlePrint} />
      </Button.Info>
    </>
  );
}

export default ExportPdf;
